module.exports = "/images/vendor/flag-icon-css/flags/4x3/bq.svg?b551016fbdf64b9d22f1c7b34a6a3a8d";